import { parseUrl } from '@tinkoff/statist-page-data/browser';
import { resolvePageUrl, w } from '@tinkoff/statist-page-data';
export function getPageUrl() {
    var location = parseUrl(w.location.href);
    return resolvePageUrl(location);
}
//# sourceMappingURL=pageUrl.js.map